import MedicalExparts from "../components/medical-exparts";
import OurServices from "../components/our-services";
import Slider from "../components/slider";

const Home = () => {
  return (
    <>
      <Slider />
      <OurServices />
      <MedicalExparts />
    </>
  );
};

export default Home;
